import { SequenceItem } from '~/shell/Store';
import { createUseReorder } from '../shared/useReorder';

export const useReorderTabs = createUseReorder({
  dataAttribute: 'data-tab-id',
  className: 'tab-drag-active',
  ghostClassName: 'drag-tab-ghost',
  styleId: 'tab-drag-optimizations',
  filterFn: (item: SequenceItem) =>
    item?.__typename === 'Tab' || item?.typename === 'Tab',
  requireDragHandle: true,
  customStyles: `
    [data-tab-id][data-drag-origin] {
      visibility: hidden !important;
    }
    .drag-tab-ghost {
      box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
      list-style: none !important;
      padding: 10px 20px 5px !important;
      border-radius: 20px 20px 0 0 !important;
      height: auto !important;
    }
    .drag-tab-ghost::before,
    .drag-tab-ghost::after,
    .drag-tab-ghost *::before,
    .drag-tab-ghost *::after {
      display: none !important;
    }
  `
});
